import { TContentElement } from "../_shared/layout/SubscriptionPreferencesLayoutModel";
import { constObjectGenerator } from "../../../../common/utils/utilsEx";
import { IUmSpAuthState } from "../_features/auth/AuthModel";
import { FC } from "react";
import { IObjectScheme } from "../../../../common/model/api/Datasources/IDataSourceScheme";
import { ILoadDynamicContentState } from "../_features/loadDynamicContent/LoadDynamicContentModel";

//temporary set up
require("lodash/templateSettings").interpolate = /{([\s\S]+?)}/g;

export const subscriptionPreferencesAT = constObjectGenerator(
    [
        "identify",
        "reenter",
        "submitCode",
        "error",
        "hasUser",
        "hasntUser",
        "hasScheme",
        "hasConsents",
        "consentChange",
        "subscriptionChange",
        "saveData",
        "revertData",
        "hasErrorsOnSaveData",
    ],
    "um/{key}/subscriptionPreferences"
);

export type TSubscriptionPreferencesMode =
    | "identify"
    | "confirm"
    | "edit"
    | "error"
    | "saving"
    | "saved";

export type TSubscriptionPreferencesScreens = "init" | "error" | "forms";

export interface ISubscriptionPreferencesState {
    screen: TSubscriptionPreferencesScreens;
    mode: TSubscriptionPreferencesMode;
    resendTimeStamp?: number;
    error?: string;
    auth?: IUmSpAuthState;
    scheme?: IObjectScheme;
    data: ISubscriptionsData;
    oldData: ISubscriptionsEditableData;
    updateErrors: IUserSubscriptionsUpdateErrors;
    dynamicContent: ILoadDynamicContentState;
}

export interface ISubscriptionsEditableData {
    generalConsents: IGeneralConsents;
    subscriptions: IUserSubscriptionsObject;
}

export interface ISubscriptionsData extends ISubscriptionsEditableData {
    subscriptionsTypes: ISubscriptionInfo[];
}

export type TSubscriptionPreferencesContentElementsMap = {
    [key in TSubscriptionPreferencesMode]: TContentElement;
};

export type TSubscriptionPreferencesScreensMap = {
    [key in TSubscriptionPreferencesScreens]: FC;
};

export interface IUserSubscriptionsObject {
    [key: number]: IUserSubscription;
}

export interface IUserSubscriptionsUpdateErrors {
    [key: string]: IUserSubscriptionsUpdateErrorItem;
}

export interface IUserSubscriptionsUpdateErrorItem {
    type: "exception" | "serverError" | "externalError";
    value: string | any;
}

export interface IConsents {
    emailconsent: boolean;
    postconsent: boolean;
    pushconsent: boolean;
    smsconsent: boolean;
}

export interface IGeneralConsents extends IConsents {
    userId: number;
}

export interface ISubscriptionInfo extends IConsents {
    id: number;
    externalId: string;
    name: string;
    description: string;
    visible: boolean;
}

export interface IUserSubscription extends IConsents {
    id: number;
    userId: number;
    subscription: number;
}
